import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const initialState = {
  name: "",
  jobTitle: "",
  companyName: "",
  phone: "",
  email: "",
  requiredService: "",
  message: "",
};

export const Contact = (props) => {
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [feedbackType, setFeedbackType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues: initialState,
    validationSchema: Yup.object({
      name: Yup.string().matches(/^[a-zA-Z\s.,-]+$/, "Name can only contain letters, spaces, and ., -")
      .max(50, "Name cannot exceed 50 characters.")
      .required("Name is required"),
      email: Yup.string().matches(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, "Invalid email format")
      .max(30, "Email cannot exceed 30 characters.")
      .required("Email is required"),
      phone: Yup.string()
    .matches(/^(?=(?:[^0-9]*[0-9]){10})[\d\s\-+]{10,}$/, "Invalid phone format")
    .max(15, "Phone cannot exceed 15 characters.")
    .required("Phone number is required"),
      companyName: Yup.string().required("Company name is required").matches(/^[a-zA-Z0-9\s.,-]+$/, "Company name can only contain letters, numbers, spaces, and ., -")
      .max(50, "Company name cannot exceed 50 characters."),
      jobTitle: Yup.string().required("Job title is required").matches(/^[a-zA-Z\s.,-]+$/, "Job title can only contain letters, spaces, and ., -")
      .max(50, "Job title cannot exceed 50 characters."),
      message: Yup.string().required("Message is required").matches(/^[a-zA-Z0-9\s.,-\\n$#%&*()\"'[\]?!/\\|_+]+$/, "Your message can contain letters, numbers, spaces, punctuation, and some special characters. Please avoid using any unsupported characters.")
      .max(200, "Message cannot exceed 200 characters."),
      requiredService: Yup.string().required("Please select a service"),
    }),
    onSubmit: async (values) => {
      setIsSubmitting(true); // Disable the button when submitting
      try {
        const response = await fetch("https://j5mrq8z04c.execute-api.eu-west-1.amazonaws.com/prod/emails", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values), // Send the form data directly
        });

        if (!response.ok) {
          throw new Error("Failed to send message. Please try again later.");
        }

        console.log("Message sent successfully!");
        displayMessage("Your message was sent successfully!", "success");
        formik.resetForm(); // Clear the form fields
      } catch (error) {
        console.error("An error occurred:", error);
        displayMessage("Your message could not be sent. Please try again!", "error");
      } finally {
        setIsSubmitting(false); // Re-enable the button when done
      }
    },
  });

  const displayMessage = (message, type) => {
    setFeedbackMessage(message);
    setFeedbackType(type);
    setTimeout(() => {
      setFeedbackMessage("");
    }, 8000);
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us an email and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Name"
                        required
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.name && formik.errors.name ? (
                        <div className="error-message d-flex align-items-center">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {formik.errors.name}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="companyName"
                        name="companyName"
                        className="form-control"
                        placeholder="Company Name"
                        required
                        value={formik.values.companyName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.companyName && formik.errors.companyName ? (
                         <div className="error-message d-flex align-items-center">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {formik.errors.companyName}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="jobTitle"
                        name="jobTitle"
                        className="form-control"
                        placeholder="Job Title"
                        required
                        value={formik.values.jobTitle}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.jobTitle && formik.errors.jobTitle ? (
                         <div className="error-message d-flex align-items-center">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {formik.errors.jobTitle}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email ? (
                         <div className="error-message d-flex align-items-center">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {formik.errors.email}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="phone"
                        name="phone"
                        className="form-control"
                        placeholder="Phone Number"
                        required
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phone && formik.errors.phone ? (
                         <div className="error-message d-flex align-items-center">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {formik.errors.phone}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <select
                        id="requiredService"
                        name="requiredService"
                        className="form-control"
                        required
                        value={formik.values.requiredService}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      >
                        <option value="">-- Select a Service --</option>
                        <option value="Scalable Web Hosting Solutions">Scalable Web Hosting Solutions</option>
                        <option value="Serverless and Microservices">Serverless and Microservices</option>
                        <option value="Cloud Migration and Automation">Cloud Migration and Automation</option>
                        <option value="Cloud Strategy and Optimization">Cloud Strategy and Optimization</option>
                        <option value="Cloud Security and Resilience">Cloud Security and Resilience</option>
                        <option value="CI/CD and Automation Solutions">CI/CD and Automation Solutions</option>
                        <option value="Other">Other Services</option>
                      </select>
                      {formik.touched.requiredService && formik.errors.requiredService ? (
                         <div className="error-message d-flex align-items-center">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {formik.errors.requiredService}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={formik.values.message}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  ></textarea>
                  {formik.touched.message && formik.errors.message ? (
                     <div className="error-message d-flex align-items-center">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {formik.errors.message}</div>
                  ) : null}
                </div>
                <div className="Success text-center">
                  {feedbackMessage && (
                    <p className={`btn text-center ${feedbackType === "success" ? 'text-success bg-success' : 'text-danger bg-danger text-white'}`}>
                      {feedbackMessage}
                    </p>
                  )}
                </div>
                <button 
                  type="submit" 
                  className="btn btn-custom btn-lg" 
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
          <h3>Contact Info</h3>
            {/* <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div> */}
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? (
                    <a href={`tel:${props.data.phone}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                      {props.data.phone}
                    </a>
                  ) : (
                    "loading"
                  )}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope"></i> Email
                </span>{" "}
                  {props.data ? (
                    <a href={`mailto:${props.data.email}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                      {props.data.email}
                    </a>
                  ) : (
                    "loading"
                  )}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"} target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"} target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-x-twitter"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.linkedin : "/"} target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.github : "/" } target="_blank" rel="noopener noreferrer">
                      <i className="fab fa-github"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 Mo2Cloud. All Rights Reserved.{" "}
          </p>
        </div>
      </div>
    </div>
  );
};
